/* global ParamsData */
export default blockTestimonials => {
    // console.log('blockTestimonials');
    const testimonialsContainer = blockTestimonials.querySelector('.testimonials-container');
    const golfid = testimonialsContainer.getAttribute('data-golfid');
    const siteid = testimonialsContainer.getAttribute('data-siteid');
    const nonce = testimonialsContainer.getAttribute('data-nonce');

    const testimonials = [];

    function buildTestimonials() {
        let html = '';

        for (let i = 0; i < testimonials.length; i++) {
            const testimonial = testimonials[i];

            if (!blockTestimonials.classList.contains('centered')) {
                html += `
                    <div class="col-md-4">
                `;
            }

            html += `
                <div class="testimonial">
                    <div class="rating" data-rate="${testimonial.rating}"></div>
                    <p>${testimonial.text}</p>
                    <div class="author">
                        <div class="author-name">${testimonial.author.name}</div>
                        <div class="date">${testimonial.author.date}</div>
                    </div>
                </div>
            `;

            if (!blockTestimonials.classList.contains('centered')) {
                html += `
                    </div>
                `;
            }
        }
        if(html != ""){
          testimonialsContainer.innerHTML = html;
          blockTestimonials.style.display = "block";
        }
    }

    function sendAjax() {
        const request = new XMLHttpRequest();
        const url = ParamsData.wp_ajax_url;
        const ajaxData = new FormData();

        ajaxData.append('action', 'golf_testimonials');
        ajaxData.append('nonce', nonce);
        ajaxData.append('golfid', golfid);
        ajaxData.append('siteid', siteid);

        request.open('POST', url, true);
        request.send(ajaxData);

        request.onprogress = () => {
            // console.log('onprogress...');
        };

        request.onload = () => {
            let response = request.response;

            if (typeof response === 'string') {
                response = JSON.parse(request.response);
            }

            for (var i = 0; i < response.length; i++) {
                testimonials[i] = response[i];
            }

            buildTestimonials();
        };

        request.onerror = () => {
            // console.log('onerror...');
        };
    }

    sendAjax();
};
